import React, { Fragment, useState } from "react";
import "./apiProductAdvantages.css";
import {
  Sidebar,
  SideBarButtons,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../layouts/layout1";
import Button from "../button/button";
import Title from "../title/title";
import Tag from "../tag/tag";
import SectionStart from "../sectionStart/sectionStart";
import CornersButton from "../button/cornersButton/cornersButton";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import LoginLink from "../loginLink/loginLink";
import AskForPlans from "../askForPlans";
import ProductMarkdown from "../productMarkdown/productMarkdown";
import ChangeLog from "../changeLog/changeLog";
import ApiDocumentationCards from "../apiDocumentationCards/apiDocumentationCards";
import Heading from "../heading/heading";
import { parseChangeLog } from "../../constants/parse/product";
import _ from "lodash";
import v4 from "uuid";

const ApiProductAdvantages = (props) => {
  const {
    disable_documentation,
    advantagesHeader,
    advantages,
    activeAdvantage,
    showAdvantage,
    overviewDisplayToggler,
    subscribeToggler,
    isLoggedIn,
    uuid,
    alias,
    isPSD2,
    apis,
    changeLog,
  } = props;

  // State to track if we're showing changelog instead of advantages
  const [showingChangeLog, setShowingChangeLog] = useState(false);

  // The description is Markdown; ProductMarkdown renders it (links, bold, lists).
  const processedAdvantage = activeAdvantage ? { ...activeAdvantage } : null;

  return (
    <SectionStart>
      <div className="nbg-hub-apis-product">
        <SideBar>
          <SidebarLeft>
            <Fragment>
              <SidebarHeader>
                <Title type="small">
                  <Tag className="display-effect">
                    {advantagesHeader && advantagesHeader.title
                      ? advantagesHeader.title.toUpperCase()
                      : "ADVANTAGES"}
                  </Tag>
                </Title>
                <Title type="descr">
                  <span
                    dangerouslySetInnerHTML={
                      advantagesHeader && advantagesHeader.body
                        ? {
                            __html: advantagesHeader.body.replace(
                              /(<([^>]+)>)/gi,
                              ""
                            ),
                          }
                        : null
                    }
                  />
                </Title>
                <SideBarButtons classNameWrapper="left-sidebar-button-wrapper">
                  {advantages &&
                    advantages.map((advantage, index) => (
                      <div
                        key={advantage.uuid || `advantage-${index}`}
                        className={
                          !showingChangeLog &&
                          processedAdvantage &&
                          advantage.uuid === processedAdvantage.uuid
                            ? "cornersButton-wrapper enable"
                            : "cornersButton-wrapper"
                        }
                      >
                        <CornersButton
                          left
                          onClick={() => {
                            setShowingChangeLog(false);
                            if (showAdvantage && advantage.uuid) {
                              showAdvantage(advantage.uuid);
                            }
                          }}
                        >
                          {advantage && advantage.title
                            ? advantage.title.toUpperCase()
                            : null}
                        </CornersButton>
                      </div>
                    ))}
                  {/* Add ChangeLog button if changeLog exists */}
                  {changeLog && changeLog.length > 0 && (
                    <div
                      className={
                        showingChangeLog
                          ? "cornersButton-wrapper enable"
                          : "cornersButton-wrapper"
                      }
                    >
                      <CornersButton
                        left
                        onClick={() => {
                          setShowingChangeLog(true);
                        }}
                      >
                        CHANGELOG
                      </CornersButton>
                    </div>
                  )}
                </SideBarButtons>
              </SidebarHeader>
              <SidebarViewAll />
            </Fragment>
          </SidebarLeft>
          <SidebarRight>
            <div className="txtBox-wrapper advantage-wrapper">
              {showingChangeLog ? (
                // Show ChangeLog content
                <div className="advantage-wrapper-inner changelog-tab-content">
                  <Title type="small">
                    <span>CHANGELOG</span>
                  </Title>
                  <div
                    className="changelog-container"
                    style={{ marginTop: "20px" }}
                  >
                    {_.orderBy(
                      parseChangeLog(changeLog),
                      [
                        (item) => {
                          // Parse version to handle numeric sorting properly
                          const version = item.version || "";
                          const parts = version.toString().split(".");
                          // Pad each part to ensure proper sorting
                          return parts
                            .map((part) => part.padStart(10, "0"))
                            .join(".");
                        },
                      ],
                      ["desc"]
                    ).map((item) => (
                      <ChangeLog key={v4()} {...item} />
                    ))}
                  </div>
                </div>
              ) : (
                // Show Advantage content
                <div className="advantage-wrapper-inner">
                  <Title type="small">
                    <span>
                      {processedAdvantage && processedAdvantage.title
                        ? processedAdvantage.title.toUpperCase()
                        : null}
                    </span>
                  </Title>
                  {processedAdvantage && (
                    <ProductMarkdown text={processedAdvantage.description} />
                  )}
                </div>
              )}
              {/* API Documentation Entries */}
              {apis && apis.length > 0 && <ApiDocumentationCards apis={apis} />}
            </div>
          </SidebarRight>
        </SideBar>
      </div>
    </SectionStart>
  );
};

export default ApiProductAdvantages;
